import React, { PureComponent } from 'react';
import debounce from 'lodash.debounce';
import Timeline from './timeline';

const RESIZE_DEBOUNCE_TIME = 300;

export default class TimelineContainer extends PureComponent {
  state = {
    width: 0,
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  setContainerWidthInState = () => {
    this.setState({
      width: this.containerRef ? this.containerRef.offsetWidth : 0,
    });
  };

  handleResize = debounce(this.setContainerWidthInState, RESIZE_DEBOUNCE_TIME);

  setContainerRef = element => {
    this.containerRef = element;
    this.setContainerWidthInState();
  };

  renderTimeline() {
    const { width } = this.state;

    if (width) {
      return <Timeline {...this.props} width={width} />;
    }

    return null;
  }

  render() {
    return (
      <div className="editor-main-container" ref={this.setContainerRef}>
        {this.renderTimeline()}
      </div>
    );
  }
}
